@if (showCards && compactCard) {
<div class="compactCardsGrid">
  @for (lesson of allLessons; track lesson; let i = $index) {
  <div
    class="compactLessonCard"
    (click)="goToEditLesson(lesson)"
  >
    @if (lesson.publishedDate) {
    <span class="compactLessonDate">{{ lesson.publishedDate | date: "MM/dd/yy" }}</span>
    }
    <h3
      class="compactLessonTitle"
      [style.fontSize]="getCompactTitleFontSize(lesson?.title)"
      [innerHTML]="lesson?.title || 'no title'"
    ></h3>
    <div class="compactLessonFooter">
      <p class="compactLessonMeta">
        {{ convertDisciplineCode(lesson?.discipline ?? "no discipline assigned") }}
        - {{ lesson?.region || "no region assigned" }}
      </p>
      @if (lesson.qualityRating != null) {
      <span class="star-rating compactRating">
        @for (star of [1, 2, 3, 4, 5]; track star) {
        <img
          [src]="
            star <= lesson.qualityRating
              ? '/./assets/images/whiteStar_16dp_Fill.png'
              : '/./assets/images/whiteStar_16dp_Empty.png'
          "
          alt="star"
          class="star-icon"
        />
        }
      </span>
      }
    </div>
  </div>
  }
</div>
} @if (showCards && !compactCard) {
<div>
  @for (lesson of allLessons; track lesson; let i = $index) {
  <div>
    <mat-card>
      <mat-card-content class="lessonDetails">
        <div class="d-flex flex-row lessonBorder">
          <div class="color-rec col-1">&nbsp;</div>
          <div
            class="lessonDetailContainer"
            style="cursor: pointer"
            (click)="goToEditLesson(lesson)"
          >
            <div
              class="d-flex flex-row top-box pl-4 align-items-center pt-2 pb-2"
              style="position: relative"
            >
              <div class="lessonTitle">
                <h3
                  class="single-line-ellipsis"
                  [innerHTML]="lesson?.title"
                ></h3>
              </div>
              <div class="lessonlabelContainer">
                @if (!lesson.title && lesson.status !== 'publish') {
                <mat-label class="noTitleLabel">
                  needs review (no title)
                </mat-label>
                } @if (!lesson.discipline && lesson.status !== 'publish' &&
                lesson.lessonWorkflowType !== 'cppFEWorkflow' &&
                lesson.lessonWorkflowType !== 'mauaFEWorkflow') {
                <mat-label class="noDiscLabel">
                  needs review (no discipline)
                </mat-label>
                } @if (lesson.lessonWorkflowType != null &&
                lesson.lessonWorkflowType !== ExtensionType.standardFEWorkflow)
                {
                <mat-label class="workflowLabel">
                  {{ convertLessonWorkflow(lesson?.lessonWorkflowType) }}
                </mat-label>
                } @if (lesson.qualityRating != null) {
                <mat-label class="qualityLabel">
                  <!-- (beta) - lesson quality: -->
                  <span class="star-rating">
                    @for (star of [1, 2, 3, 4, 5]; track star) {
                    <img
                      [src]="
                        star <= lesson.qualityRating
                          ? '/./assets/images/whiteStar_16dp_Fill.png'
                          : '/./assets/images/whiteStar_16dp_Empty.png'
                      "
                      alt="star"
                      class="star-icon"
                    />
                    }
                  </span>
                </mat-label>
                } @if (lesson.projectCodes?.[0] !== null &&
                lesson.projectCodes.length > 0) {
                <mat-label class="projectCodeLabel">
                  associated project lookback code:
                  {{ lesson.projectCodes[0] }}</mat-label
                >
                } @if (showStatusLabel) {
                <mat-label
                  class="statusLabel"
                  [ngStyle]="{
                    color: getStatusTextColor(lesson.status),
                    'background-color': getStatusBackgroundColor(lesson.status)
                  }"
                >
                  {{ displayStatus(lesson.status) }}</mat-label
                >
                }
              </div>
            </div>
            @if (disciplines && disciplines.length > 0 && showDisc) {
            <div
              class="d-flex flex-row justify-content-start w-100 bottom-box pl-4 pt-2 pb-2"
              style="gap: 5%"
            >
              @if (lesson?.lessonWorkflowType !== ExtensionType.standardFEWorkflow) {
              <div class="businessUnit info">
                <h5 class="single-line-ellipsis">business unit</h5>
                <p class="single-line-ellipsis">
                  {{ lesson?.businessUnit ?? "no business unit assigned" }}
                </p>
              </div>
              }
              <div class="discipline info">
                <h5 class="single-line-ellipsis">discipline</h5>
                <p class="single-line-ellipsis">
                  {{
                    convertDisciplineCode(
                      lesson?.discipline ?? "no discipline assigned"
                    )
                  }}
                </p>
              </div>
              <div class="description info">
                <h5 class="single-line-ellipsis">description</h5>
                <p
                  class="single-line-ellipsis"
                  [innerHTML]="lesson?.description || 'no description given'"
                ></p>
              </div>
              <div class="potentialCauseSummary info">
                <h5 class="single-line-ellipsis">potential cause</h5>
                <p class="single-line-ellipsis">
                  {{ lesson?.potentialCause ?? "no potential cause given" }}
                </p>
              </div>
              <div class="recommendation info">
                <h5 class="single-line-ellipsis">recommendation</h5>
                <p class="single-line-ellipsis">
                  {{ lesson?.recommendation ?? "no recommendation given" }}
                </p>
              </div>
              <div class="pointOfContact info">
                <h5 class="single-line-ellipsis">point of contact</h5>
                <p class="single-line-ellipsis">
                  {{
                    lesson?.pointOfContact?.fullName ??
                      "no point of contact assigned"
                  }}
                </p>
              </div>
            </div>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  }
</div>
}
